// Plain CommonJS (same rule as ground.js): the server tick requires it and the browser imports the label helper.
// Departing-flight status is INFORMATION ONLY (Val, 2026-11-01 Q-7): nothing here, and nothing that uses it, moves a pickup.
const time = (v) => (v == null || v === '' ? NaN : new Date(v).getTime());
const iso = (v) => (Number.isFinite(time(v)) ? new Date(time(v)).toISOString() : null);
function airportCode(airport) {
    if (!airport) return '';
    if (typeof airport === 'string') return airport.toUpperCase();
    return String(airport.code_iata || airport.iata || String(airport.code_icao || airport.code || '').replace(/^K(?=[A-Z]{3}$)/, '')).toUpperCase();
}
function localDate(value, timeZone) {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: timeZone || 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(value)); } catch (e) { return null; }
}

// The FlightAware flight that is this departure: leaves the given airport on the given local date. Ambiguous or none -> null.
function pickDepartureFlight(payload, query) {
    const flights = (payload && (payload.flights || payload.scheduled)) || [];
    const matches = flights.filter((f) => {
        const out = f.scheduled_out || f.scheduled_off;
        const origin = f.origin || {};
        const zone = (origin && origin.timezone) || query.time_zone;
        return Number.isFinite(time(out)) && (!query.airport || airportCode(origin) === String(query.airport).toUpperCase()) && localDate(out, zone) === query.flight_date;
    });
    return matches.length === 1 ? matches[0] : null;
}

// One FlightAware flight -> the stored status. A delay is the estimated minus the scheduled gate departure.
function departureStatusFrom(flight) {
    if (!flight) return { status: 'Unknown' };
    const scheduled = iso(flight.scheduled_out || flight.scheduled_off);
    const estimated = iso(flight.estimated_out || flight.estimated_off);
    let delay = null;
    if (scheduled && estimated) delay = Math.max(0, Math.round((time(estimated) - time(scheduled)) / 60000));
    else if (Number.isFinite(Number(flight.departure_delay))) delay = Math.max(0, Math.round(Number(flight.departure_delay) / 60));
    let status = 'On time';
    if (flight.cancelled === true || /cancel/i.test(String(flight.status || ''))) status = 'Cancelled';
    else if (flight.actual_out || flight.actual_off) status = 'Departed';
    else if (delay != null && delay >= 15) status = 'Delayed';
    else if (!scheduled) status = 'Unknown';
    return { status, delay_minutes: delay, scheduled_out: scheduled, estimated_out: estimated, gate: flight.gate_origin || null, terminal: flight.terminal_origin || null };
}

// Plain-English line for staff screens ("Delayed 45 min · now 6:15 PM · Gate B12").
function departureStatusLabel(s, timeZone) {
    if (!s || !s.status) return '';
    const parts = [s.status === 'Delayed' && s.delay_minutes ? `Delayed ${s.delay_minutes} min` : s.status];
    if (s.status === 'Delayed' && s.estimated_out) {
        try { parts.push(`now ${new Intl.DateTimeFormat('en-US', { timeZone: timeZone || 'America/New_York', hour: 'numeric', minute: '2-digit' }).format(new Date(s.estimated_out))}`); } catch (e) { /* time stays off the line */ }
    }
    if (s.gate && s.status !== 'Cancelled') parts.push(`Gate ${s.gate}`);
    return parts.join(' · ');
}

module.exports = { pickDepartureFlight, departureStatusFrom, departureStatusLabel };
